(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lb-casino/assets/javascripts/lobby-page.js') >= 0) return;  svs.modules.push('/modules/lb-casino/assets/javascripts/lobby-page.js');
"use strict";


class LobbyPage {
  constructor() {
    if (svs.core.detect.formfactor.mobile()) {
      if (svs.core.detect.feature('ft-floating-swish-buttons')) {
        new svs.casino.quick_transaction.TransactionButtons();
      }
    }
    new svs.components.casino.Categories(svs.lb_casino.data.renderModel.casinoSection);
  }
}
setGlobal('svs.lb_casino.initLobbyPage', () => new LobbyPage());

 })(window);